module.exports = __webpack_public_path__ + "img/icon-user-clock.14535dd5.svg";